
import { Badge as MuiBadge, BadgeProps } from '@mui/material';


interface IBadgeProps extends BadgeProps {
    vertical?: 'top' | 'bottom';
    horizontal?: 'left' | 'right';
}


const Badge: React.FC<IBadgeProps> = (props) => {
    return (
        <MuiBadge 
            {...props} 
            className=''
            anchorOrigin={{
                vertical: props.vertical ?? 'top',
                horizontal: props.horizontal ?? 'right'
            }}
            componentsProps={{
                badge: {
                    className: `boxshadow-default borderradius-default ${props.className}`
                }
            }}
        >
            {props.children}
        </MuiBadge>
    );
}

export default Badge;